export const VISUAL_MODES = ["DEFAULT", "PARABLE", "TENSION", "CRITICAL"];

export const DEFAULT_VISUAL_STATE = Object.freeze({
  mode: "DEFAULT",
  intensity: 1,
});

const VISUAL_MODE_ALIASES = Object.freeze({
  utilitario: "DEFAULT",
  analysis: "DEFAULT",
  financeiro: "DEFAULT",
  juridico: "DEFAULT",
  estrategia: "DEFAULT",
  graca_ceus: "DEFAULT",
  saude: "DEFAULT",
  health: "DEFAULT",
  utilitario_saude: "DEFAULT",
  alerta: "CRITICAL",
  parabolico: "PARABLE",
  parabolic: "PARABLE",
  parabola: "PARABLE",
});

const VISUAL_MODE_SET = new Set(VISUAL_MODES);

function normalizeVisualModeKey(raw) {
  const key = String(raw || "").trim();
  if (!key) return DEFAULT_VISUAL_STATE.mode;
  const upper = key.toUpperCase();
  if (VISUAL_MODE_SET.has(upper)) return upper;
  return VISUAL_MODE_ALIASES[key.toLowerCase()] || DEFAULT_VISUAL_STATE.mode;
}

export function sanitizeVisualState(input) {
  return {
    mode: normalizeVisualModeKey(input?.mode || input?.visual_mode),
    intensity: DEFAULT_VISUAL_STATE.intensity,
  };
}

export function resolveVisualStateFromPayload(payload) {
  if (!payload || typeof payload !== "object") return null;
  const modeRaw = payload.visualMode ?? payload.visual_mode;
  const modeStr = typeof modeRaw === "string" ? modeRaw.trim() : "";
  if (!modeStr) return null;
  const upperMode = modeStr.toUpperCase();
  if (!VISUAL_MODE_SET.has(upperMode)) return null;
  return {
    mode: upperMode,
    intensity: DEFAULT_VISUAL_STATE.intensity,
  };
}

export function shouldApplyVisualState(current, next) {
  if (!next) return false;
  const cur = sanitizeVisualState(current || DEFAULT_VISUAL_STATE);
  const normalizedNext = sanitizeVisualState(next);
  return cur.mode !== normalizedNext.mode;
}

export function withAppliedAt(visualState, now = Date.now()) {
  return {
    ...sanitizeVisualState(visualState),
    appliedAt: now,
  };
}
